import { render } from "./ReportDisplayField.vue?vue&type=template&id=5ffbdf2b&scoped=true"
import script from "./ReportDisplayField.vue?vue&type=script&lang=js"
export * from "./ReportDisplayField.vue?vue&type=script&lang=js"

import "./ReportDisplayField.vue?vue&type=style&index=0&id=5ffbdf2b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffbdf2b"]])

export default __exports__